import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledRecommendedActionsIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#D5F0F7"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_32512_58483)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M22.5859 9.5C22.9837 9.50004 23.3652 9.65818 23.6465 9.93945L27.0605 13.3535C27.3418 13.6348 27.5 14.0163 27.5 14.4141V28C27.5 29.3807 26.3807 30.5 25 30.5H15C13.6193 30.5 12.5 29.3807 12.5 28V12C12.5 10.6193 13.6193 9.5 15 9.5H22.5859Z",
					fill: "white",
					stroke: "#1F3B44"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15 17.5H25",
					stroke: "#1F3B44",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15 20H25",
					stroke: "#1F3B44",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15 22.5H21",
					stroke: "#1F3B44",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.5 13.5L23.5 10.5V13.5H26.5Z",
					fill: "#4B7987"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23 10V13C23 13.5523 23.4477 14 24 14H27",
					stroke: "#1F3B44",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 27,
					cy: 27,
					r: 4.5,
					fill: "white",
					stroke: "#1F3B44"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25 27L26.5 28.5L29 26",
					stroke: "#1F3B44",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_32512_58483",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 8)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilledRecommendedActionsIcon);
const Memo = memo(ForwardRef);
export default Memo;
